import React, { useEffect, useMemo, useState } from "react";
import { Button, Divider, Modal, Spin, Tabs } from "antd";
import { api } from "../../Requests/Api";
import { useTranslation } from "react-i18next";
import chatCountersDefault, {
    AGGREGATED,
    AGGREGATED_BY_USER_ID,
    FACEBOOK,
    INSTAGRAM,
    WEB_CHAT,
    WHATSAPP,
} from "./constants";
import { useAppContext } from "../../State/Global/AppContext";
import CommonTabContent from "./CommonTabContent";
import UserTabContent from "./UserTabContent";

function ChatCounters({
    visible,
    countersModalCb,
    usersList,
    usersPaginatorHasNext,
    nextUsersPageCb,
}) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [channelFilter, setChannelFilter] = useState(AGGREGATED);
    const { appState } = useAppContext();

    const currentUserId = useMemo(() => {
        return appState.agent.id;
    }, [appState.agent.id]);

    const currentUserIsAdmin = useMemo(() => {
        return appState.agent.isAdmin;
    }, [appState.agent.isAdmin]);

    const countersDefault = chatCountersDefault.chatCounters;
    countersDefault.aggregatedByUserId[currentUserId] = chatCountersDefault.userChatsCounters;

    const [counters, setCounters] = useState(countersDefault);

    function tabClick(tabKey, mouseEvent) {
        setChannelFilter(tabKey);
    }

    useEffect(() => {
        if (visible) {
            setIsLoading(true);
            api.chats()
                .getAggregatedCounters()
                .then((res) => {
                    setCounters(res.data);
                    setIsLoading(false);
                })
                .catch((err) => {
                    setIsLoading(false);
                });
        }
    }, [visible]);

    return (
        <Modal
            bodyStyle={{
                maxHeight: "500px",
                overflow: "scroll",
                paddingTop: "0px",
                padding: "0px 24px",
            }}
            title={t("counters.chatStatus")}
            open={visible}
            onCancel={() => countersModalCb(false)}
            footer={[
                <Button type="primary" onClick={() => countersModalCb(false)}>
                    {t("accept")}
                </Button>,
            ]}
        >
            <Spin spinning={isLoading}>
                <Tabs defaultActiveKey={AGGREGATED} onTabClick={tabClick}>
                    <Tabs.TabPane tab={t("counters.aggregatedFilter")} key={AGGREGATED}>
                        <CommonTabContent counters={counters[channelFilter]} />
                        <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                        <UserTabContent
                            countersByUser={counters[AGGREGATED_BY_USER_ID]}
                            currentUserId={currentUserId}
                            currentUserIsAdmin={currentUserIsAdmin}
                            usersList={usersList}
                            usersPaginatorHasNext={usersPaginatorHasNext}
                            nextUsersPageCb={nextUsersPageCb}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={t("counters.whatsappFilter")} key={WHATSAPP}>
                        <CommonTabContent counters={counters[channelFilter]} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={t("counters.instagramFilter")} key={INSTAGRAM}>
                        <CommonTabContent counters={counters[channelFilter]} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={t("counters.facebookFilter")} key={FACEBOOK}>
                        <CommonTabContent counters={counters[channelFilter]} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={t("counters.webChatFilter")} key={WEB_CHAT}>
                        <CommonTabContent counters={counters[channelFilter]} />
                    </Tabs.TabPane>
                </Tabs>
            </Spin>
        </Modal>
    );
}
export default ChatCounters;
